
import Localbase from 'localbase'

let db
export const createDb = () => {
    db = new Localbase('barcode')
    db.config.debug = false;
}
export const deleteDb = () => {
    db.delete();
}

//add data in index db
export const add = (collectionName, data) => {
    return db.collection(collectionName)
    .add(data, collectionName.toLowerCase())
}

//add data in a collection in index db
export const addToCollection = async (collectionName, key, object) => {
    return db.collection(collectionName).add(object, key)
}

//get all data in a collection
export const getAllOfTable = (collectionName) => {
    createDb()
    console.log('getAllOfTable', collectionName);
    return db.collection(collectionName).get()
}

//get all data from a collection along with keys
export const getAllOfTableWithKeys = async (collectionName) => {
    createDb()
    return new Promise((resolve, reject) => { db.collection(collectionName).get({ keys: true }).then(data => {
        resolve(data)
        return data
    }).catch((err) => {
        reject(false)
        return err
    }) })
}

//add single product in Products collection
export const addSingleProduct = (newLead) => {
    return new Promise((resolve, reject) => {
        const mKey = newLead.ProductName
        return db.collection('Products')
        .add(newLead, mKey).then((res) => resolve(res)).catch(err => reject(false))
    })
}

//add single record in Inmate collection
export const addSingleInmate = (newLead) => {
    return new Promise((resolve, reject) => {
        const mKey = newLead.code
        return db.collection('Inmates')
        .add(newLead, mKey).then((res) => resolve(res)).catch(err => reject(false))
    })
}

//add inmate id strings for a meal period after submit 
export const addInmateSubmitFormealPeriod = (mealId, idString) => {
    const newLead = {inmateIds: idString}
    return new Promise((resolve, reject) => {
        return db.collection('InmateSubmit')
        .add(newLead, mealId).then((res) => resolve(res)).catch(err => reject(false))
    })
}

//get patient ids scanned for a meal period
export const getSingleMealPeriodId = (id) => {
    createDb()
    return db.collection('InmateSubmit').doc(id).get()
}

export const updateSingleMealPeriodId = (key, idString) => {
    const newLead = {inmateIds: idString}
    return db.collection('InmateSubmit').doc(key).update(newLead)
}

export const getSingleRecordUsingKey = (collectionName, id) => {
    createDb()
    return db.collection(collectionName).doc(id).get()
}

//get single inmate details from inmate collection
export const getSingleInmate = (id) => {
    createDb()
    return db.collection('Inmates').doc(id).get()
}

//get single product detail from Products collection
export const getSingleProduct = (id) => {
    createDb()
    return db.collection('Products').doc(id).get()
}

export const updateProduct = (key, object) => {
    return db.collection('Products').doc(key).update(object)
}

export const addAllProducts = (leadList) => {
    return Promise.all(leadList.map(lead => {
        lead.IsLmsSync = true;
        db.collection('Products')
        .add(lead, lead.LeadId)
    }))
}

export const removeAllProducts = (ProductName) => {
    return db.collection('Products').doc(ProductName).delete();
}

export const addSingleAccountProduct = (newLead) => {
    return new Promise((resolve, reject) => {
        const mKey = newLead.AccountId
        return db.collection('AccountProducts')
        .add(newLead, mKey).then((res) => resolve(res)).catch(err => reject(false))
    })
}

export const getSingleAccountProduct = (id) => {
    createDb()
    return db.collection('AccountProducts').doc(id).get()
}

export const updateAccountProduct = (key, object) => {
    return db.collection('AccountProducts').doc(key).update(object)
}

export const removeAllAccountProducts = () => {
    return db.collection('AccountProducts').delete()
}

export const removeInmateSubmitData = () => {
    return db.collection('InmateSubmit').delete()
}

export const removeCollection = (collectionName) => {
    return db.collection(collectionName).delete()
}

export const addAllAccountProducts = (leadList) => {
    return Promise.all(leadList.map(lead => {
        lead.IsLmsSync = true;
        db.collection('AccountProducts')
        .add(lead, lead.LeadId)
    }))
}

export const addAllHistoricalLeads = (leadList) => {
    return Promise.all(leadList.map(lead => {
        lead.IsLmsSync = true;
        db.collection('HistoricalLead')
            .add(lead, lead.LeadId)
    }))
}

export const addUserData = (userData) => {
    return db.collection('UserInfo')
    .add(userData, userData.id)
}
export const addLastSyncTime = (syncTime, key) => {
    return db.collection('LastSyncTimes')
    .add(syncTime, key)
}
export const getLastSyncByKey = (key) => {
    if (!db) {
        createDb();
        return db.collection('LastSyncTimes').doc(key).get()
    } else {
        return db.collection('LastSyncTimes').doc(key).get()
    }
}
export const getConfigData = (key) => {
    if (!db) {
        createDb();
        return db?.collection('configData').doc(key).get()
    } else {
        return db?.collection('configData').doc(key).get()
    }
}
export const getUserSession = (key) => {
    return db?.collection('UserInfo').get()
}

export const deleteDocFromCollection = (collectionName, key) => {
    return db.collection(collectionName).doc(key).delete();
}
